import { createAsyncThunk } from "@reduxjs/toolkit";
import client, {
  ApiError,
  AsyncThunkConfig,
  isAxiosError,
} from "../../api/axiosConfig";
import { dispatchNotification } from "../../utils/redux";
import { sendEmailURL } from "../../utils/paths";
import { SendEmailFitersData } from "../../api/sendEmailApi";
import { EmailSenderFilters } from "../../api/psychologicalLabApi";

interface ApiResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: SendEmailFitersData;
}

export const loadSendEmailFiltersData = createAsyncThunk<
  SendEmailFitersData,
  void,
  AsyncThunkConfig
>("selectedPsychLab/loadSendEmailFiltersData/get", async (args, thunkAPI) => {
  try {
    const response = await client.request<ApiResponse>({
      url: `${sendEmailURL}filters/`,
    });

    return response.data.results;
  } catch (err) {
    if (isAxiosError(err) && err.response != null) {
      const extractedError = err.response.data as ApiError;

      dispatchNotification("error", extractedError.message, true);

      return thunkAPI.rejectWithValue(extractedError);
    }
    dispatchNotification("error");
    throw err;
  }
});

export const fetchSendEmails = createAsyncThunk<
  void,
  EmailSenderFilters,
  AsyncThunkConfig
>("selectedPsychLab/fetchSendEmails/post", async (emailData, thunkAPI) => {
  try {
    await client.post(`${sendEmailURL}send/`, emailData);
  } catch (err) {
    if (isAxiosError(err) && err.response != null) {
      const extractedError = err.response.data as ApiError;

      dispatchNotification("error", extractedError.message, true);

      return thunkAPI.rejectWithValue(extractedError);
    }

    dispatchNotification("error");
    throw err;
  }
});
